import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { ResponseEntity } from '~client/model/response-entity';

/* User APIs pertaining to newsletters */
export class NewsletterController extends BaseController {
  /*
   * Allows user to subscribe to newsletter notifications
   */
  public subscribe$(emailAddress: string): Observable<ResponseEntity> {
    return this.put$(`/newsletter/public/subscribe?emailAddress=${emailAddress}`);
  }

  /*
   * Allows user to subscribe for invites to a specific event
   */
  public eventSubscribe$(emailAddress: string): Observable<ResponseEntity> {
    return this.put$(`/newsletter/public/event/subscribe?emailAddress=${emailAddress}`);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/controller/newsletter-controller.ts